import React, { Component, Fragment } from 'react'
import { Modal, Spin, Form, Button, Input, Icon, Popconfirm, Alert } from 'antd'

class tagEditForm extends Component {
  handleEdit = (e) => {
    e.preventDefault()

    const { id, form: { validateFields }, handleEdit } = this.props

    validateFields((err, values) => {
      if (!err) {
        handleEdit(id, values.name)
      }
    })
  }

  render () {
    const { value, onCancel, form: { getFieldDecorator } } = this.props

    return <Form layout='inline' onSubmit={this.handleEdit}>
      <Form.Item>
        {getFieldDecorator('name', {
          rules: [{ required: true,
            message: 'Please input tag name',
            max: 23,
            pattern: /^[^, ][ a-zA-Z_\\-\\.0-9]*/
          }],
          initialValue: value
        })(
          <Input name='name' maxLength={23} />
        )}
      </Form.Item>
      <Form.Item>
        <Button
          type='indigo'
          htmlType='submit'
        >Save</Button>
      </Form.Item>
      <Form.Item>
        <Button
          onClick={onCancel}
        >Cancel</Button>
      </Form.Item>
    </Form>
  }
}

const TagEditForm = Form.create()(tagEditForm)

class ModalTagsManager extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: {
        status: false,
        message: null
      },
      editable: null
    }
  }

  componentDidMount () {
    const { getTags } = this.props
    getTags()
  }

  handleCancel = (e) => {
    const { close } = this.props
    close()
  }

  handleEdit = (id, name) => {
    const { editTag, getStorage } = this.props

    editTag(id, name)
      .then((response) => {
        if (response.data.error) {
          this.setState({
            error: {
              status: true,
              message: response.data.error.message
            }
          })
          return
        }

        this.setState({
          error: {
            status: false,
            message: null
          }
        })

        getStorage()
      })
      .then(() => this.handleEditReset())
  }

  handleEditInit = (id) => {
    this.setState({
      editable: id
    })
  }

  handleEditReset = () => {
    this.setState({
      editable: null
    })
  }

  handleRemove = (id) => {
    const { deleteTag, getTags, getStorage } = this.props
    deleteTag(id)
      .then(() => getStorage())
      .then(() => getTags())
  }

  handleCreate = (e) => {
    e.preventDefault()

    const { createTag, getTags, form: { validateFields, setFieldsValue } } = this.props

    validateFields((err, values) => {
      if (!err) {
        createTag(values.name)
          .then((response) => {
            if (response.data.error) {
              this.setState({
                error: {
                  status: true,
                  message: response.data.error.message
                }
              })
              return
            }

            this.setState({
              error: {
                status: false,
                message: null
              }
            })

            setFieldsValue({
              name: ''
            })

            getTags()
          })
      }
    })
  }

  render () {
    const { editable, error } = this.state
    const { status, fetching, list, form: { getFieldDecorator } } = this.props

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Manage tags'
        visible={status}
        onCancel={this.handleCancel}
        destroyOnClose
        width={480}
        footer={null}
      >
        { error.status && <Alert message={error.message} type='error' style={{ marginBottom: '2rem' }} /> }

        <Spin spinning={fetching}>

          <Form onSubmit={this.handleCreate}>
            <div className='tags-form'>
              <div className='tags-form__input'>
                <Form.Item>
                  {getFieldDecorator('name', {
                    rules: [{
                      required: true,
                      message: 'Please input tag name',
                      max: 23,
                      pattern: /^[^, ][ a-zA-Z_\\-\\.0-9]*/
                    }]
                  })(
                    <Input name='_name' maxLength={23} />
                  )}
                </Form.Item>
              </div>
              <div className='tags-form__button'>
                <Form.Item>
                  <Button
                    type='indigo'
                    htmlType='submit'
                    disabled={fetching}
                  >Create</Button>
                </Form.Item>
              </div>
            </div>
          </Form>

          <div className='tags'>
            <div className='tags__list'>
              { list.map(tag =>
                <div key={tag.id} className='tags__item'>

                  { tag.id === editable
                    ? <div className='tags__tag'>
                      <TagEditForm
                        id={tag.id}
                        value={tag.value}
                        handleEdit={this.handleEdit}
                        onCancel={this.handleEditReset}
                      />
                    </div>
                    : <Fragment>
                      <div className='tags__tag'>{tag.value}</div>
                      <div className='tags__controls'>
                        <div className='tags__control'>
                          <Icon
                            type='edit'
                            style={{ fontSize: '1.6rem' }}
                            onClick={() => this.handleEditInit(tag.id)}
                          />
                        </div>
                        <div className='tags__control'>
                          <Popconfirm placement='top' title='Are you sure to delete this tag?' onConfirm={() => this.handleRemove(tag.id)} okText='Yes' cancelText='No'>
                            <Icon
                              type='delete'
                              style={{ fontSize: '1.6rem' }}
                            />
                          </Popconfirm>
                        </div>
                      </div>
                    </Fragment> }
                </div>) }
            </div>
          </div>
        </Spin>
      </Modal>
    )
  }
}

export default Form.create()(ModalTagsManager)



// WEBPACK FOOTER //
// ./src/components/Modals/ModalTagsManager/ModalTagsManager.jsx